var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteSecondaryIcon = function SvgDeleteSecondaryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.224 10.699 1.908 3.865h10.184L10.776 10.7c-.097.504-.163.84-.233 1.096-.069.247-.128.364-.186.444a1.25 1.25 0 0 1-.474.391c-.089.042-.216.078-.47.098-.266.021-.608.022-1.122.022H5.71c-.514 0-.856 0-1.121-.021-.255-.02-.382-.057-.47-.099l-.322.678.321-.678a1.25 1.25 0 0 1-.474-.391c-.058-.08-.117-.197-.186-.444-.07-.256-.136-.592-.233-1.096Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeWidth: 1.5,
    d: "M4.75 3a2.25 2.25 0 0 1 4.5 0v.404h-4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8.5 6.75h-3M1 3.483h12"
  })));
};
export default SvgDeleteSecondaryIcon;